import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DeviceContext from "../../../utils/indentifyDevice";
import { DashboardDesktop } from "./Desktop/DashboardDesktop";
import { DashboardMobile } from "./Mobile/DashboardMobile";
import di from "../HoldingReports/di/servicelocator";
import moment from "moment";
import { ERports } from "@adapters/presenters/action-interfaces/Reports/DashboardSummary";
import { useNavigate, createSearchParams } from "react-router-dom";
export const Dashboard = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const navigate = useNavigate();
    // fetch the start date of cuurect financial year
    let today = new Date();
    let startDateOfCurrFinYear;
    const { selectedMember, familyDetails: { myAccCode }, } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    if (today.getMonth() + 1 <= 3) {
        startDateOfCurrFinYear = new Date(new Date().getFullYear() - 1, 3, 1);
    }
    else {
        startDateOfCurrFinYear = new Date(new Date().getFullYear(), 3, 1);
    }
    const [fromDate, setFromDate] = React.useState(sessionStorage.getItem("fromDate") ||
        moment(startDateOfCurrFinYear).format("yyyy-MM-DD"));
    const { data: dashboardDataStore, loader: showShimmer, errorData: dashboardDataStoreError, } = useSelector((state) => state.dashboardSummary[props.reportName]);
    const [dashboardData, setDashboardData] = useState([]);
    const [toDate, setToDate] = React.useState(sessionStorage.getItem("toDate") ||
        moment().subtract(1, "days").format("yyyy-MM-DD"));
    useEffect(() => {
        if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode)
            props.getDashboardData(fromDate, toDate, (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) !== myAccCode, selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode);
    }, [selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode]);
    const [loader, setLoader] = React.useState(false);
    React.useEffect(() => {
        setLoader(showShimmer);
    }, [showShimmer]);
    const setDashboardDatainReqFormat = () => {
        if (dashboardDataStore.length > 0) {
            switch (props.reportName) {
                case ERports.HOLDINGS: {
                    let temp = dashboardDataStore.map((x) => {
                        return {
                            assetClass: x.assetClass,
                            totalHoldingPrc: x.totalHoldingPrc,
                            invVal: x.investmentValue,
                            mktVal: x.marketValue,
                            returnPercentage: x.pnlPercent,
                            pnl: x.pnl,
                            assetCode: x.assetCode,
                        };
                    });
                    setDashboardData(temp);
                    break;
                }
                case ERports.PNL: {
                    let temp = dashboardDataStore.map((x) => {
                        return {
                            assetClass: x.assetClass,
                            totalHoldingPrc: x.totalHoldingPrc,
                            invVal: x.investmentValue,
                            mktVal: x.marketValue,
                            realisedGain: x.realisedGain,
                            returnPercentage: x.returnPrc,
                        };
                    });
                    setDashboardData(temp);
                    break;
                }
            }
        }
        else
            setDashboardData([]);
    };
    useEffect(() => {
        setDashboardDatainReqFormat();
    }, [dashboardDataStore]);
    const last_trading_date = useSelector((state) => { var _a, _b, _c; return (_c = (_b = (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.HoldingSummary) === null || _c === void 0 ? void 0 : _c.date; });
    const goToRespectiveHoldingTab = (selectedEle) => {
        var _a;
        if ((props === null || props === void 0 ? void 0 : props.reportName) === ERports.HOLDINGS) {
            di.holdingReport.saveProdAssetDropDown(null, null);
            (_a = props === null || props === void 0 ? void 0 : props.setHeadingName) === null || _a === void 0 ? void 0 : _a.call(props, "Holdings");
            let state = {
                goToHoldingAssetTab: {
                    assetCategory: selectedEle.assetCode,
                },
            };
            navigate({
                pathname: "",
                search: createSearchParams({
                    reportName: "Holding",
                }).toString(),
            }, {
                state,
            });
        }
    };
    return (React.createElement(React.Fragment, null, DeviceContext().isDesktop ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "date-text" },
            React.createElement("span", { className: `date-left text-muted` }, (_a = props.summary) === null || _a === void 0 ? void 0 : _a.closePriceDate)),
        React.createElement(DashboardDesktop, { dashBoardData: dashboardData, isRealisedGainPresent: props.isRealisedGainPresent, shimmer: loader, setShimmer: setLoader, summaryShimmerCount: props.reportName === ERports.HOLDINGS ? 4 : 3, summary: props.summary && props.reportName === ERports.HOLDINGS
                ? [
                    {
                        title: "Total Investment",
                        value: props.summary.totalInvestment.valueOf(),
                        integer: false,
                        externalClassName: "dashboard_summary",
                    },
                    {
                        title: "Current Value",
                        value: props.summary.currentValue.valueOf(),
                        integer: false,
                        externalClassName: "dashboard_summary",
                    },
                    {
                        title: "Total P&L",
                        value: props.summary.totalPnL.valueOf(),
                        percentageValue: props.summary.totalPnLChange.valueOf(),
                        integer: true,
                        externalClassName: "dashboard_summary",
                    },
                    {
                        title: "Day's P&L",
                        value: props.summary.daysPnL.valueOf(),
                        percentageValue: props.summary.daysPnLChange.valueOf(),
                        integer: true,
                        externalClassName: "dashboard_summary bgPorcelain",
                    },
                ]
                : [
                    {
                        title: "Total P&L",
                        value: (_b = props.summary) === null || _b === void 0 ? void 0 : _b.totalPnl,
                        integer: true,
                        percentageValue: (_c = props.summary) === null || _c === void 0 ? void 0 : _c.totalPnlChangePercent,
                        externalClassName: "summary_box",
                    },
                    {
                        title: "Realized P&L",
                        value: (_d = props.summary) === null || _d === void 0 ? void 0 : _d.realisedPnl,
                        integer: true,
                        percentageValue: (_e = props.summary) === null || _e === void 0 ? void 0 : _e.realisedPnlChangePercent,
                        externalClassName: "summary_box",
                    },
                    {
                        title: "Unrealized P&L",
                        value: (_f = props.summary) === null || _f === void 0 ? void 0 : _f.unrealisedPnl,
                        integer: true,
                        percentageValue: (_g = props.summary) === null || _g === void 0 ? void 0 : _g.unrealisedPnlChangePercent,
                        externalClassName: "summary_box",
                    },
                    // {
                    //   title: "Day's P&L",
                    //   value: (
                    //     props.summary as IPNLSummaryEntity
                    //   )?.daysPnLChange.valueOf(),
                    //   integer: true,
                    //   // percentageValue: (
                    //   //   props.summary as IPNLSummaryEntity
                    //   // )?.daysPnLChange.valueOf(),
                    //   externalClassName: "summary_box",
                    // },
                ], isSummarize: props.enableSummary, setSummarize: props.setSummary, goToRespectiveHoldingTab: goToRespectiveHoldingTab, showStreamOption: props.showStreamOption, streamClickDisabled: props.streamClickDisabled, stream: props.stream, setStream: props.setStream, reportName: props.reportName, dashboardError: dashboardDataStoreError }))) : (React.createElement(DashboardMobile, { dashBoardData: dashboardData, isSummarize: props.enableSummary, isRealisedGainPresent: props.isRealisedGainPresent, shimmer: loader, setShimmer: setLoader, summary: props.summary && props.reportName === ERports.HOLDINGS
            ? [
                {
                    title: "Total Investment",
                    value: props.summary.totalInvestment.valueOf(),
                    integer: false,
                    externalClassName: "dashboard_summary",
                },
                {
                    title: "Current Value",
                    value: props.summary.currentValue.valueOf(),
                    integer: false,
                    externalClassName: "dashboard_summary",
                },
                {
                    title: "Total P&L",
                    value: props.summary.totalPnL.valueOf(),
                    percentageValue: props.summary.totalPnLChange.valueOf(),
                    integer: true,
                    externalClassName: "dashboard_summary",
                },
            ]
            : [
                {
                    title: "Total P&L",
                    value: (_h = props.summary) === null || _h === void 0 ? void 0 : _h.totalPnl,
                    integer: true,
                    percentageValue: (_j = props.summary) === null || _j === void 0 ? void 0 : _j.totalPnlChangePercent,
                    externalClassName: "summary_box",
                },
                {
                    title: "Realized P&L",
                    value: (_k = props.summary) === null || _k === void 0 ? void 0 : _k.realisedPnl,
                    integer: true,
                    percentageValue: (_l = props.summary) === null || _l === void 0 ? void 0 : _l.realisedPnlChangePercent,
                    externalClassName: "summary_box",
                },
                {
                    title: "Unrealized P&L",
                    value: (_m = props.summary) === null || _m === void 0 ? void 0 : _m.unrealisedPnl,
                    integer: true,
                    percentageValue: (_o = props.summary) === null || _o === void 0 ? void 0 : _o.unrealisedPnlChangePercent,
                    externalClassName: "summary_box",
                },
            ], setSummarize: props.setSummary, Totalsummary: props.summary && props.reportName === ERports.HOLDINGS
            ? [
                {
                    title: "Day's P&L",
                    value: props.summary.daysPnL.valueOf(),
                    percentageValue: props.summary.daysPnLChange.valueOf(),
                    integer: true,
                    externalClassName: "dashboard_dayspnl-mob bgPorcelain",
                },
            ]
            : [
            // {
            //   title: "Day's P&L",
            //   value: (
            //     props.summary as IPNLSummaryEntity
            //   ).daysPnLChange.valueOf(),
            //   // percentageValue: (
            //   //   props.summary as IPNLSummaryEntity
            //   // ).daysPnLChange.valueOf(),
            //   integer: true,
            //   externalClassName: "dashboard_dayspnl-mob bgPorcelain",
            // },
            ], goToRespectiveHoldingTab: goToRespectiveHoldingTab, dashboardError: dashboardDataStoreError, reportName: props.reportName }))));
};
